import { render, staticRenderFns } from "./ShortageItemsTable.vue?vue&type=template&id=452c0fe0&scoped=true&"
import script from "./ShortageItemsTable.vue?vue&type=script&lang=js&"
export * from "./ShortageItemsTable.vue?vue&type=script&lang=js&"
import style0 from "./ShortageItemsTable.vue?vue&type=style&index=0&id=452c0fe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452c0fe0",
  null
  
)

export default component.exports